import type LayoutConfigTypes from '@/types/interfaces/theme/metronic/config/LayoutConfigTypes';

const finishRegisterLayoutConfig: LayoutConfigTypes = {
  general: {
    mode: 'system',
    primaryColor: '#eb2b8e',
    pageWidth: 'default',
    layout: 'light-header',
    iconsType: 'duotone'
  },
  header: {
    display: true,
    default: {
      container: 'fluid',
      fixed: {
        desktop: true,
        mobile: true
      },
      menu: {
        display: true,
        iconType: 'bootstrap'
      }
    }
  },
  sidebar: {
    display: false,
    default: {
      minimize: {
        desktop: {
          enabled: true,
          default: false,
          hoverable: true
        }
      },
      menu: {
        iconType: 'bootstrap'
      }
    }
  },
  toolbar: {
    display: true,
    container: 'fluid',
    fixed: {
      desktop: true,
      mobile: true
    }
  },
  pageTitle: {
    display: true,
    breadcrumb: false,
    direction: 'row'
  },
  content: {
    container: 'fluid'
  },
  footer: {
    display: false,
    container: 'fluid',
    fixed: {
      desktop: true,
      mobile: false
    }
  },
  illustrations: {
    set: 'sketchy-1'
  },
  scrolltop: {
    display: true
  }
};

export default finishRegisterLayoutConfig;
